export const DELIVERABLE_TYPE_FILE = 'file';
export const DELIVERABLE_TYPE_APP = 'app';
export const DELIVERABLE_TYPE_DISTRO = 'distro';
export const DELIVERABLE_TYPE_CM4G = 'cm4g';
export const DELIVERABLE_TYPE_BUNDLE = 'bundle';
export const DELIVERABLE_SCHEMA = 'file_v1';
export const FETCH_DELIVERABLES_AMOUNT_INCREMENT = 500;
